"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Back = _interopRequireDefault(require("Layouts/Back"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _ProjectForm = _interopRequireDefault(require("../../Components/Forms/Models/Projects/ProjectForm"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
var _Routing = require("Functions/Routing");
const NewProjectPage = () => {
  return /*#__PURE__*/_react.default.createElement(_Back.default, {
    page_title: "Nouveau dossier"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "o-content"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    href: (0, _Routing.URL)('AdminProjectsDashboard'),
    className: (0, _bemit.default)('c-flat-btn') + ' u-margin-bottom-15'
  }, '<', " Retour aux dossiers"), /*#__PURE__*/_react.default.createElement(_ProjectForm.default, null)));
};
var _default = exports.default = NewProjectPage;
